import React, { useEffect } from "react";
import { useSelector } from "react-redux";
// import { useHistory } from "react-router-dom";
// import axiosInstance from "../../Redux/axios/AxiosInstance";
// import { quick_quotes } from "../../Redux/actions/NumBikeation";
// import { Button, Form,
//     Radio,message
// } from 'antd/lib';

export default function Ownerdisplay() {
  const ownerInfo = useSelector((state) => state.addressdetail.info1);
  // console.log("ownerInfo",ownerInfo)
  return (
    <>
      <div className="d-flex px-3 row row-cols-xl-3 row-cols-lg-3 row-cols-md-2 row-cols-sm-1 row-cols-1">
        <div className="py-2 px-2 text-nowrap col-xl-4 col-lg-4 col-md-6 col-sm-6 col-6">
          <div className="indivtexthead">FULL NAME</div>
          <div className="indivtext">{ownerInfo?.Owner}</div>
        </div>
        <div className="py-2 px-2 text-nowrap col-xl-4 col-lg-4 col-md-6 col-sm-6 col-6">
          <div className="indivtexthead">MOBILE NUMBER</div>
          <div className="indivtext">{ownerInfo?.Mobile}</div>
        </div>
        <div className="py-2 px-2 text-nowrap col-xl-4 col-lg-4 col-md-6 col-sm-6 col-6">
          <div className="indivtexthead">EMAIL ID</div>
          <div className="indivtext">{ownerInfo?.Email}</div>
        </div>
        <div className="mt-1 px-2 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
          <p
            style={{ color: "#00000066", fontSize: "16px", fontWeight: "700" }}
          >
            Communication Address
          </p>
        </div>
        <div className="py-2 px-2 text-nowrap col-xl-4 col-lg-4 col-md-6 col-sm-6 col-6">
          <div className="indivtexthead">ADDRESS</div>
          <div className="indivtext">{ownerInfo?.Address}</div>
        </div>
        <div className="py-2 px-2 text-nowrap col-xl-4 col-lg-4 col-md-6 col-sm-6 col-6">
          <div className="indivtexthead">CITY</div>
          <div className="indivtext">{ownerInfo?.City}</div>
        </div>
        <div className="py-2 px-2 text-nowrap col-xl-4 col-lg-4 col-md-6 col-sm-6 col-6">
          <div className="indivtexthead">PINCODE</div>
          <div className="indivtext">{ownerInfo?.Pincode}</div>
        </div>
      </div>
    </>
  );
}
